import { HeaderIconButton, SmartLink } from '@components';
import { useCartContext } from '@context/CartContext';
import { useAppSelector, useAuth } from '@hooks';
import { Box } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';

export const LightningCartButton = () => {
  const { isAuthenticated } = useAuth();
  const cartPageUrl = useAppSelector(getSpecialPage('cartPage'));
  const { setFocusOnInput } = useCartContext();

  return isAuthenticated ? (
    <Box className='cart-link-block' onClick={() => setFocusOnInput(true)}>
      <SmartLink href={cartPageUrl}>
        <HeaderIconButton iconName='BoltIcon' sx={{ ml: 'auto' }} />
      </SmartLink>
    </Box>
  ) : null;
};
